var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hide.includes('settings'))?_c('SidbearSettingsGroup',{attrs:{"active":"","title":"Image Settings","content-class":"border-0"}},[(_vm.linked)?_c('b-form-group',[_c('button',{staticClass:"flex p-0 text-[11px] hover:bg-gray-100 items-center text-dark border rounded-[4px] w-[114px] h-[30px] justify-content-center gap-[5px] cursor-pointer font-[500] hover:text-[#3D82EA] text-[#7E7E7E]",on:{"click":() => _vm.unlinkSid()}},[_vm._v(" Unlink Styles "),_c('i',{staticClass:"fa fa-link text-primary"})])]):_vm._e(),_c('sid-upload-image',{attrs:{"sid":`.--${_vm.section.sid}--image`,"title":"","rule-name":"content"}}),_c('b-form-group',{attrs:{"label":"Alt image text"}},[_c('b-input',{model:{value:(_vm.config.alt),callback:function ($$v) {_vm.$set(_vm.config, "alt", $$v)},expression:"config.alt"}})],1),_c('sid-range-slider',{attrs:{"rule-name":"width","sid":`.el-image.--${_vm.section.sid}--image`,"default-dimension":"%","dimensions":['%', 'vw', 'px'],"label":"Image Size","var":"--width","measurement":"width"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Display Setting")]),_c('sid-select',{staticClass:"w-[100px]",attrs:{"sid":`.--${_vm.section.sid}--wrapper`,"rule-name":"display","searchable":false,"options":[
            {
              label: 'Block',
              value: ''
            },
            {
              label: 'Inline',
              value: 'inline-flex',
            }
          ]}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Position")]),_c('sid-select',{staticClass:"w-[138px]",attrs:{"sid":`.--${_vm.section.sid}--wrapper`,"rule-name":"position","searchable":false,"options":[
            {
              label: 'Static',
              value: ''
            },
            {
              label: 'Fixed',
              value: 'fixed',
            },
            {
              label: 'Absolute',
              value: 'absolute',
            }
          ]}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Z-Index")]),_c('sid-input',{staticClass:"!w-[59px]",attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"z-index","default-dimension":""}})],1)]),_c('sid-flip',{attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"scale"}}),_c('sid-align',{attrs:{"sid":`.--${_vm.section.sid}--container`,"rule-name":"justify-content","label":"Alignment"}})],1):_vm._e(),_c('SidbearSettingsGroup',{attrs:{"title":"Filters"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-background-filters',{attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"filter"}}),_c('sid-range-slider',{attrs:{"label":"Opacity","sid":`.--${_vm.section.sid}--image`,"rule-name":"opacity","default-dimension":'',"dimensions":[],"min":0,"max":1,"step":0.1}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-background-filters',{attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"filter","presudo":":hover"}}),_c('sid-range-slider',{attrs:{"label":"Opacity","sid":`.--${_vm.section.sid}--image`,"rule-name":"opacity","default-dimension":'',"dimensions":[],"min":0,"presudo":":hover","max":1,"step":0.1}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Mask"}},[_c('sid-background-mask',{attrs:{"sid":`.--${_vm.section.sid}--image`}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Transform"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-transform',{attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"transform","section":_vm.section}}),_c('sid-translate',{attrs:{"sid":`.--${_vm.section.sid}--wrapper`,"rule-name":"translate"}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-transform',{attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"transform","presudo":":hover","section":_vm.section}}),_c('sid-translate',{attrs:{"sid":`.--${_vm.section.sid}--wrapper`,"presudo":":hover","rule-name":"translate"}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Animations"}},[_c('b-form-group',[_c('animations',{attrs:{"sid":_vm.section.uid,"animations":_vm.config.animations}})],1),_c('hover-animations',{model:{value:(_vm.hoverAnimation),callback:function ($$v) {_vm.hoverAnimation=$$v},expression:"hoverAnimation"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Drop Shadow"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"box-shadow"}})],1),_c('template',{slot:"Hover"},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--image`,"presudo":":hover","rule-name":"box-shadow"}})],1)],2)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--image`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--image`,"rule-name":"border","angles":[
            {
              text: '',
              value: 'top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius'
            }
          ]}})],1),_c('template',{slot:"Hover"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--image`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--image`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--image`,"presudo":":hover","rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--image`,"rule-name":"border","presudo":":hover","angles":[
            {
              text: '',
              value: 'top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius'
            }
          ]}})],1)],2)],1),(!_vm.hide.includes('action'))?_c('SidbearSettingsGroup',{attrs:{"title":"Click Action"}},[_c('ButtonAction',{staticClass:"mb-0",attrs:{"config":_vm.config}})],1):_vm._e(),(!_vm.hide.includes('tooltip'))?_c('tooltip-mod',{attrs:{"config":_vm.section,"component-name":"tooltip"}}):_vm._e(),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--wrapper`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--wrapper`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }